import { useState, useContext, useEffect, useCallback } from 'react';
import { ContentWrapper, Textbox } from 'components/generic';
import { ProfileDetailsContext } from 'providers/profile-provider';
import { getValuesById, dropDown } from 'utils';
import { useSelector } from 'react-redux';
import Images from 'assets/Images';
import { cloneDeep } from 'lodash';
import './style.scss';

const CompanyDetails = props => {
	const context = useContext(ProfileDetailsContext);
	const { createObj, setCreateObj } = context;
	const [editbutton, setEditButton] = useState({ information: false, address: false, registration: false });
	const [c_companyDetails, setCompanyDetails] = useState({});
	const [c_verification, setVerification] = useState({});

	const referenceData = useSelector(state => state?.referenceData?.data);

	const handledata = (e, key, subkey, k) => {
		setCreateObj(prevState => {
			const data = cloneDeep(prevState);
			data[key][subkey][k] = e;
			return data;
		});
	};

	useEffect(() => {
		setCompanyDetails(createObj?.c_companyDetails);
		setVerification(createObj?.c_verification);
	}, [createObj]);

	const country = getValuesById(dropDown('rd_countryCodes', referenceData), c_companyDetails?.basic_details?.c_country);

	const handleButtonClick = async key => {
		['save', 'cancel']?.includes(key) && (await props.onClickButton({ key, createObj: key === 'cancel' ? context.originalObj : createObj }));
		setEditButton({ information: false, address: false, registration: false, [key]: true });
	};

	const buttons = (
		<div className='flex-end'>
			<div className='basic-details__button--cancel' onClick={() => handleButtonClick('cancel')}>
				Cancel
			</div>
			<div className='basic-details__button align-center' onClick={() => handleButtonClick('save')}>
				Save
			</div>
		</div>
	);

	const editButton = useCallback(key => {
		return (
			<div className='basic-details__button align-center' onClick={() => handleButtonClick(key)}>
				<img src={Images['edit-blue']} /> Edit
			</div>
		);
	}, []);

	const uploadContainer = useCallback(
		obj =>
			!editbutton[obj.sectionKey] ? (
				<div className='upload__container'>
					<label>{obj?.label}</label>
					<p className='upload__container--display'>{obj?.displayName || '-'}</p>
				</div>
			) : (
				<div className='upload__container'>
					<label>
						{obj?.label} {obj?.mandatory && <sup>*</sup>}
					</label>
					<div className='upload__container--img'>
						<input type='file' id='upload-logo' onChange={e => handledata(e?.target?.files[0], obj?.baseKey, obj?.subkey, obj?.key)} />
						<div className='flex-start'>
							<img src={Images.attachment} />
							<span className='upload__container--display'>{obj?.displayName || 'Attach'}</span>
						</div>
					</div>
				</div>
			),
		[editbutton]
	);

	return (
		<>
			<ContentWrapper shadow>
				<div className='basic-details'>
					<div className='space-between'>
						<h4>Company Information</h4>
						{!editbutton?.information && editButton('information')}
					</div>
					<div className='row'>
						<div className='col-5'>
							<Textbox label='Company Name' mandatory display={!editbutton?.information} placeholder='Enter' value={c_companyDetails?.basic_details?.c_name} disabled />
						</div>
						<div className='col-5'>
							<Textbox label='Country' mandatory placeholder='Enter' display={!editbutton?.information} value={country?.at()?.value} disabled />
						</div>
						<div className='col-5'>
							<Textbox label='Company Email' mandatory display={!editbutton?.information} placeholder='Enter' value={c_companyDetails?.basic_details?.c_companyMail} disabled />
						</div>
						<div className='col-5'>
							<Textbox
								type='Number'
								label='Company Phone Name'
								mandatory
								placeholder='Enter'
								display={!editbutton?.information}
								value={c_companyDetails?.basic_details?.c_companyPhone}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'basic_details', 'c_companyPhone')}
							/>
						</div>
						<div className='col-5'>
							{uploadContainer({
								label: 'Company Logo',
								baseKey: 'c_companyDetails',
								subkey: 'basic_details',
								key: 'c_logo',
								sectionKey: 'information',
								displayName: c_companyDetails?.basic_details?.c_logo?.fileName || c_companyDetails?.basic_details?.c_logo?.name
							})}
						</div>
					</div>
					{editbutton?.information && buttons}
				</div>

				<div className='basic-details'>
					<div className='space-between'>
						<h4>Company Address Details</h4>
						{!editbutton?.address && editButton('address')}
					</div>
					<div className='row'>
						<div className='col-5'>
							<Textbox
								label='Address Line 1'
								mandatory
								placeholder='Enter'
								display={!editbutton?.address}
								value={c_companyDetails?.address_details?.c_addressLine1}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'address_details', 'c_addressLine1')}
							/>
						</div>
						<div className='col-5'>
							<Textbox
								label='Address Line 2'
								placeholder='Enter'
								display={!editbutton?.address}
								value={c_companyDetails?.address_details?.c_addressLine2}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'address_details', 'c_addressLine2')}
							/>
						</div>

						<div className='col-5'>
							<Textbox
								label='City'
								mandatory
								placeholder='Enter'
								display={!editbutton?.address}
								value={c_companyDetails?.address_details?.c_city}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'address_details', 'c_city')}
							/>
						</div>
						<div className='col-5'>
							<Textbox
								label='State'
								mandatory
								placeholder='Enter'
								display={!editbutton?.address}
								value={c_companyDetails?.address_details?.c_state}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'address_details', 'c_state')}
							/>
						</div>
						<div className='col-5'>
							<Textbox
								label='Pincode'
								mandatory
								placeholder='Enter'
								display={!editbutton?.address}
								value={c_companyDetails?.address_details?.c_pincode}
								onChange={e => handledata(e?.target?.value, 'c_companyDetails', 'address_details', 'c_pincode')}
							/>
						</div>
					</div>
					{editbutton?.address && buttons}
				</div>

				<div className='basic-details'>
					<div className='space-between'>
						<h4>Business Registration Details</h4>
						{!editbutton?.registration && editButton('registration')}
					</div>
					<div className='row'>
						<div className='col-5'>
							<Textbox
								label='Business Registration Number'
								mandatory
								placeholder='Enter'
								display={!editbutton?.registration}
								value={c_verification?.c_businessRegVerification?.c_registrationNumber}
								onChange={e => handledata(e?.target?.value, 'c_verification', 'c_businessRegVerification', 'c_registrationNumber')}
							/>
						</div>
						<div className='col-5'>
							{uploadContainer({
								mandatory: true,
								label: 'Proof of Identity',
								baseKey: 'c_verification',
								subkey: 'c_businessRegVerification',
								key: 'c_identityProof',
								sectionKey: 'registration',
								displayName: c_verification?.c_businessRegVerification?.c_identityProof?.fileName || c_verification?.c_businessRegVerification?.c_identityProof?.name
							})}
						</div>
						<div className='col-5'>
							{uploadContainer({
								mandatory: true,
								label: 'Business Registration Certificate',
								baseKey: 'c_verification',
								subkey: 'c_businessRegVerification',
								key: 'c_registrationCertificate',
								sectionKey: 'registration',
								displayName: c_verification?.c_businessRegVerification?.c_registrationCertificate?.fileName || c_verification?.c_businessRegVerification?.c_registrationCertificate?.name
							})}
						</div>
						<div className='col-5'>
							{uploadContainer({
								label: 'Financial Statement',
								baseKey: 'c_verification',
								subkey: 'c_businessRegVerification',
								key: 'c_financialStatement',
								sectionKey: 'registration',
								displayName: c_verification?.c_businessRegVerification?.c_financialStatement?.fileName || c_verification?.c_businessRegVerification?.c_financialStatement?.name
							})}
						</div>
					</div>
					{editbutton?.registration && buttons}
				</div>
			</ContentWrapper>
		</>
	);
};

export default CompanyDetails;
